import type { IconName } from '@/ui/Icon/icons'
import type { ResourceIcon, ResourceKindInfo } from '../types/api'

/** Kinds are identified by glyph and word, never colour (Chip card, D24). Glyphs: iconography's kind table. */
const KIND_ICON: Record<ResourceIcon, IconName> = {
  web: 'globe',
  note: 'file-text',
  database: 'database',
  git: 'commit',
  github: 'commit', // D111: no inventory glyph yet; Git's is the closest
  route: 'commit',
  webhook: 'lightning-bolt',
  clock: 'clock',
  list: 'file', // D111: no inventory glyph yet
  mcp: 'link-2',
  plan: 'clipboard',
  question: 'question-mark-circled',
  generic: 'file',
}

/** Label and glyph for a kind from `/api/resource-kinds`; the raw kind and `file` until it loads. */
export function kindDisplay(
  kind: string,
  registered: ResourceKindInfo[] | undefined,
): { label: string; icon: IconName } {
  const meta = registered?.find((k) => k.kind === kind)
  return {
    label: meta?.display.label ?? kind,
    icon: KIND_ICON[meta?.display.icon ?? 'generic'] ?? 'file',
  }
}
